{
  "pull": "Zum Neuladen nach unten ziehen...",
  "release": "Zum Neuladen loslassen...",
  "labelRows": "Zeilen",
  "tableRowsDisplayed": "{from}-{to} von {count}",
  "tableFirstPage": "Erste Seite",
  "tableLastPage": "Letzte Seite",
  "tableNextPage": "Nächste Seite",
  "tablePreviousPage": "Vorherige Seite",
  "tableSearchTooltip": "Suchen",
  "tableSearchPlaceholder": "Suchen",
  "tableSearchAriaLabel": "Suchen",
  "tableSearch": "Suchen...",
  "tableClearSearchAriaLabel": "Suche löschen",
  "tableRowsPerPage": "Zeilen pro Seite:",
  "sortBy": "SORTIEREN NACH",
  "showFiltersAndSorting": "Filter & Sortierung anzeigen",
  "hideFiltersAndSorting": "Filter & Sortierung ausblenden",
  "searchPlaceholder": "Suchen nach {{searchKeys}}",
  "all": "Alle",
  "noRecords": "Keine Datensätze anzuzeigen",
  "listTable": {
    "filters": "Filter",
    "columns": "Spalten",
    "drawers": {
      "columns": {
        "title": "Spalten",
        "columns": {
          "show": "Anzeigen",
          "columnName": "Spaltenname"
        }
      },
      "filters": {
        "title": "Filter"
      },
      "buttons": {
        "cancel": "Schließen",
        "restoreDefaults": "Standards wiederherstellen",
        "apply": "Anwenden"
      }
    }
  }
}
